/** U+2066 LEFT-TO-RIGHT ISOLATE — opens a run that reads left-to-right. */
const LRI = '\u2066';
/** U+2069 POP DIRECTIONAL ISOLATE — closes the nearest open isolate. */
const PDI = '\u2069';

/**
 * Pins a value to left-to-right order when it sits inside Hebrew or Arabic copy.
 *
 * Masked phones, IDs and emails mix digits with neutral characters such as `*`,
 * `@` or `+`. The Unicode bidi algorithm resolves those neutrals to RTL when the
 * paragraph is RTL and then reorders the runs around them, so `054****188`
 * reaches the screen as `188****054`. Isolating the value keeps its own order
 * and, unlike a `dir="ltr"` wrapper on the whole line, leaves the surrounding
 * sentence right-to-left.
 *
 * Use it on the interpolated value, not on the sentence:
 * `t('otp.subtitle', { phone: ltrIsolate(masked) })`.
 */
export function ltrIsolate(value: string | undefined | null): string {
  return value ? `${LRI}${value}${PDI}` : '';
}
